import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DayHours, HoursRange, HoursResponse } from '../models/hours.models';

/** Scheduler working hours API (logixi-be schedule-hours module). `fitterId` null = the workshop. */
@Injectable({
  providedIn: 'root'
})
export class ScheduleHoursService {
  private readonly endpoint = environment.api.endpoint + 'schedule-hours';

  constructor(private http: HttpClient) { }

  get(from: string, to: string): Observable<HoursResponse> {
    return this.http.get<HoursResponse>(`${this.endpoint}?from=${from}&to=${to}`);
  }

  saveWeekday(fitterId: number | null, dayOfWeek: number, day: DayHours): Observable<unknown> {
    return this.http.put(`${this.base(fitterId)}/pattern/${dayOfWeek}`, day);
  }

  saveDate(fitterId: number | null, date: string, day: DayHours): Observable<unknown> {
    return this.http.put(`${this.base(fitterId)}/day/${date}`, day);
  }

  /** Default: the date goes back to the usual week. */
  resetDate(fitterId: number | null, date: string): Observable<unknown> {
    return this.http.delete(`${this.base(fitterId)}/day/${date}`);
  }

  /** Own hours on: the fitter's usual week (index = day of week, 0 = Sunday). */
  setOwnWeek(fitterId: number, days: DayHours[]): Observable<unknown> {
    return this.http.put(`${this.endpoint}/fitter/${fitterId}/pattern`, { days });
  }

  /** Own hours off: the fitter follows the workshop week again. */
  clearOwnWeek(fitterId: number): Observable<unknown> {
    return this.http.delete(`${this.endpoint}/fitter/${fitterId}/pattern`);
  }

  /** Several days for one owner, all saved or none (the Night button writes a day and the next). */
  saveDays(fitterId: number | null, writes: { date?: string; dayOfWeek?: number; day: DayHours }[]): Observable<unknown> {
    return this.http.put(`${this.endpoint}/days`, { fitterId, writes });
  }

  applyRange(range: HoursRange): Observable<{ changed: number }> {
    return this.http.put<{ changed: number }>(`${this.endpoint}/range`, range);
  }

  private base(fitterId: number | null): string {
    return fitterId === null ? `${this.endpoint}/workshop` : `${this.endpoint}/fitter/${fitterId}`;
  }
}
